import { createFileRoute, useRouter } from '@tanstack/react-router'
import { useEffect } from 'react'

export const Route = createFileRoute('/')({
  component: IndexPage,
})

function IndexPage() {
  const router = useRouter()

  useEffect(() => {
    const token =
      typeof window !== 'undefined'
        ? sessionStorage.getItem('teamforge_token')
        : null

    if (token) {
      router.navigate({ to: '/home' })
    } else {
      router.navigate({ to: '/login' })
    }
  }, [router])

  return null
}
